import {
    GET_SUB_USERS_LIST_REQUEST,
    GET_SUB_USERS_LIST_SUCCESS,
    GET_SUB_USERS_LIST_FAILED,
    CHANGE_USER_COUNTRIES_REQUEST,
    CHANGE_USER_COUNTRIES_SUCCESS,
    CHANGE_USER_COUNTRIES_FAILED
} from "../Actions/UserManagementActions"

const initialState = {
    loading: false,
    success: false,
    subUsersList: [],
    subUsersList_loader: false,

  };

export const UserManagementReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case GET_SUB_USERS_LIST_REQUEST:
        return {
          ...state,
          subUsersList_loader: true,
        };
      case GET_SUB_USERS_LIST_SUCCESS:
        return {
          ...state,
          subUsersList_loader: false,
          subUsersList: action.payload
        };
      case GET_SUB_USERS_LIST_FAILED:
          return{
              ...state,
              subUsersList_loader: false
          };
      case CHANGE_USER_COUNTRIES_REQUEST:
        return{
          ...state,
          loading: true
        };
      case CHANGE_USER_COUNTRIES_SUCCESS:
        return{
          ...state,
          loading: false
        };
      case CHANGE_USER_COUNTRIES_FAILED:
        return{
          ...state,
          loading: false
        };

      default:
        return state;
    }
  };